module.exports = __webpack_public_path__ + "img/seo_gchess_item03.0eb6b44.webp";